export default __webpack_public_path__ + "static/media/csu-logo-footer.cecfb036.jpg";